(function() {
  'use strict';
  const STORAGE_KEY = 'ms_workspace_config';

  function load() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function save(config) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
    } catch (e) {
      console.error('Unable to set workspace config', e);
    }
  }

  function clear() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      console.error('Unable to clear workspace config', e);
    }
  }

  function init() {
    const configEl = document.getElementById('workspace-config-data');
    if (configEl) {
      try {
        save(JSON.parse(configEl.textContent));
      } catch (e) {
        console.error('Unable to parse workspace config data', e);
      }
    }

    // Clear workspace config on revert to super admin
    document.querySelectorAll('#top-nav-return-to-super').forEach(el => {
      el.addEventListener('click', () => clear());
    });

    // Login page–specific logic
    if (!document.querySelector('[data-workspace-login]')) return;

    if (!configEl && new URLSearchParams(window.location.search).has('workspace_id')) {
      // workspace_id was in URL but server didn't render config — workspace was invalid
      clear();
    }

    // Wire up "Switch Workspace" links
    document.querySelectorAll('[data-action="switch-workspace"]').forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        clear();
        window.location.href = el.getAttribute('href') || '/workspaces';
      });
    });
  }

  window.workspaceConfig = {
    load: load,
    clear: clear
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
